<div ngClass="wf-diagram-connector-{{direction}}" class="wf-diagram-connector-border overflow-hidden" *ngIf="hasParent"></div>
<div class="wf-diagram-block-box cs-d-flex align-items-center view-mode-{{viewMode}}" #nodeRef [ngClass]="{'audit-highlight': isAuditHightlight}" [id]="blockId">
    <div class="cs-flex-1 pos-rlt cs-d-flex flex-column task-status-{{taskStatus['status']}} task-audit-{{ nodeOptions.audit?.eventId }}">
        <button class="add-node-btn cursor-pointer" type="button" *ngIf="nodeOptions.showAddChild && !isNew" (click)="addNode()">
            <img [src]="iconImageUrl" alt="{{isNew}}"/>
        </button>
        <ng-container *ngTemplateOutlet="nodeTemplate ? nodeTemplate : defaultNodeTemplate; context:{
            nodeOptions:nodeOptions,
            isNew:isNew,
            blockHeaderText: blockHeaderText
        }"> </ng-container>
    </div>
</div>
<div ngClass="wf-diagram-connector-{{direction}}" class="wf-diagram-connector-border" *ngIf="children?.length"></div>

<ng-template #defaultNodeTemplate>
    <div>Content is empty</div>
</ng-template>

<ng-template #conditionEdge>
    <div  class="task-block cs-condition-task-block self-center cs-condition-{{ name }}-edge">
        <span>{{ condition['text'] }}</span>
        <span class=""> {{ operatorsDisplayText[condition['operator']] }} </span>
        <span>{{ getValue(condition['col_name'], condition['value']) }}</span>
    </div>
    <div ngClass="wf-diagram-connector-{{direction}}" class="wf-diagram-connector-border self-center"></div>
</ng-template>

<ng-template #elseBlock>
    <ng-container *ngIf="condition; then conditionEdge"></ng-container>
    <div [id]="blockId"
         [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''"
         class="task-block cs-else-task-block cs-d-flex flex-column align-items-center hidden"
         [style.justify-content]="'center'" [ngClass]="{'hidden': children.length > 0, 'highlight-deletable': highlighDeletableNode && children.length == 0}">
        <div class="node-icon-content">End</div>
    </div>
</ng-template>

<ng-template #scheduledActivityBlock let-headerText="blockHeaderText">
    <ng-container *ngIf="condition; then conditionEdge"></ng-container>
    <div [id]="blockId"
         [ngClass]="{'highlight-deletable': highlighDeletableNode}"
         class="task-block cs-scheduled-activity-task-block cs-d-flex flex-column align-items-center"
         [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''">
        <div *ngIf="!isNew" class="pos-abt-full cursor-pointer task-action-link" (click)="editNode()"></div>
        <div class="node-heading mb-10">{{headerText}}</div>
        <div class="node-icon-content">
            <span><i class="mr-10 far fa-clipboard-list-check fa-lg" aria-hidden="true"></i></span>
            <span translate>Schedule activity</span>
        </div>
        <hr class="separator"/>
        <div class="cs-flex-1">
            <div class="cs-d-flex m-b--5">
                <div class="m-r--10">Description:</div>
                <div class="font-bold">{{ scheduledActivityBlockDisplay.description }}</div>
            </div>
            <div class="cs-d-flex m-b--5">
                <div class="m-r--10 no-warp">Activity type: </div>
                <div class="font-bold"> <i class="{{ scheduledActivityBlockDisplay.activityIcon }} m-r--10"></i> {{ scheduledActivityBlockDisplay.activityType }}</div>
            </div>
            <div class="cs-d-flex m-b--5">
                <div class="m-r--10 no-warp">Due date: </div>
                <div class="font-bold">{{ scheduledActivityBlockDisplay.dueDate }}</div>
            </div>
            <div class="cs-d-flex">
                <div class="m-r--10 no-warp">Assign to:</div>
                <div class="font-bold text-left">{{ scheduledActivityBlockDisplay.assignTo }}</div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #emailBlock let-nodeData="node" let-headerText="blockHeaderText">
    <ng-container *ngIf="condition; then conditionEdge"></ng-container>
    <div [id]="blockId"
         [ngClass]="{'highlight-deletable': highlighDeletableNode}"
         class="task-block cs-email-task-block cs-d-flex flex-column align-items-center"
         [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''">
        <div *ngIf="!isNew" class="pos-abt-full cursor-pointer task-action-link" (click)="editNode()"></div>
        <div class="node-heading mb-10">{{headerText}}</div>
        <div class="node-icon-content">
            <span><i class="mr-10 fal fa-envelope fa-lg" aria-hidden="true"></i></span>
            <span translate>Email</span>
        </div>
        <hr class="separator"/>
        <div class="cs-flex-1">
            <div class="cs-d-flex m-b--5">
                <div class="m-r--10">To:</div>
                <div class="font-bold">{{ emailBlockDisplay.toEmailTag }}</div>
            </div>
            <div class="cs-d-flex m-b--5" *ngIf="emailBlockDisplay.ccEmailTag != ''">
                <div class="m-r--10">Cc: </div>
                <div class="font-bold">{{ emailBlockDisplay.ccEmailTag }}</div>
            </div>
            <div class="cs-d-flex m-b--5" *ngIf="emailBlockDisplay.bccEmailTag != ''">
                <div class="m-r--10">Bcc: </div>
                <div class="font-bold">{{ emailBlockDisplay.bccEmailTag }}</div>
            </div>
            <div class="cs-d-flex">
                <div class="m-r--10">Subject:</div>
                <div class="font-bold text-left">{{ emailBlockDisplay.subject }}</div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #smsBlock let-nodeData="node" let-headerText="blockHeaderText">
    <ng-container *ngIf="condition; then conditionEdge"></ng-container>
    <div [id]="blockId"
         [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''" class="task-block cs-sms-task-block cs-d-flex flex-column align-items-center">
        <div *ngIf="!isNew" class="pos-abt-full cursor-pointer task-action-link" (click)="editNode()"></div>
        <div class="node-heading mb-10">{{headerText}}</div>
        <div class="node-icon-content">
            <span><i class="mr-10 fa-light fa-comment-sms fa-lg" aria-hidden="true"></i></span>
            <span translate>SMS</span>
        </div>
        <hr class="separator"/>
        <div class="cs-flex-1">
            <div class="cs-d-flex m-b--5">
                <div class="m-r--10">To:</div>
                <div class="font-bold">{{smsBlockDisplay.toAddress}}</div>
            </div>
            <div class="cs-d-flex">
                <div class="m-r--10">Title:</div>
                <div class="font-bold text-left">{{ model['title']}}</div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #sendJobReportBlock let-headerText="blockHeaderText">
    <ng-container *ngIf="condition; then conditionEdge"></ng-container>
    <div [id]="blockId"
         [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''" class="task-block cs-send-job-task-block cs-d-flex flex-column align-items-center">
        <div *ngIf="!isNew" class="pos-abt-full cursor-pointer task-action-link" (click)="editNode()"></div>
        <div class="node-heading mb-10">{{headerText}}</div>
        <div class="node-icon-content">
            <span><i class="mr-10 fa-light fa-clipboard-list fa-lg" aria-hidden="true"></i></span>
            <span translate>Send job report</span>
        </div>
        <hr class="separator"/>
        <div class="cs-flex-1">
            <div class="cs-d-flex m-b--5">
                <div class="m-r--10">To:</div>
                <div class="font-bold">{{ sendJobReportDisplay.toEmailTag }}</div>
            </div>
            <div class="cs-d-flex">
                <div class="m-r--10">Email template:</div>
                <div class="font-bold text-left">{{ sendJobReportDisplay.templateName }}</div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #setCustomFieldBlock let-headerText="blockHeaderText">
    <ng-container *ngIf="condition; then conditionEdge"></ng-container>
    <div [id]="blockId"
         [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''" class="task-block cs-send-job-task-block cs-d-flex flex-column align-items-center">
        <div *ngIf="!isNew" class="pos-abt-full cursor-pointer task-action-link" (click)="editNode()"></div>
        <div class="node-heading mb-10">{{headerText}}</div>
        <div class="node-icon-content">
            <span><i class="mr-10 fa-light fa-file-pen fa-lg" aria-hidden="true"></i></span>
            <span translate>Set custom field</span>
        </div>
        <hr class="separator"/>
        <div class="cs-flex-1">
            <div class="cs-d-flex m-b--5">
                <div class="m-r--10">Template field to get:</div>
                <div class="font-bold">{{ setCustomFieldDisplay.templateFieldToGet }}</div>
            </div>
            <div class="cs-d-flex">
                <div class="m-r--10">Custom field to set:</div>
                <div class="font-bold text-left">{{ setCustomFieldDisplay.customFieldToSet }}</div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #notificationBlock let-nodeData="node" let-headerText="blockHeaderText">
    <ng-container *ngIf="condition; then conditionEdge"></ng-container>
    <div [id]="blockId"
         [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''"
         class="task-block cs-notification-task-block cs-d-flex flex-column align-items-center">
        <div *ngIf="!isNew" class="pos-abt-full cursor-pointer task-action-link" (click)="editNode()"></div>
        <div class="node-heading mb-10">{{headerText}}</div>
        <div class="node-icon-content">
            <span><i class="mr-10 fa-light fa-earth-americas fa-lg" aria-hidden="true"></i></span>
            <span translate>notification</span>
        </div>
        <hr class="separator"/>
        <div class="cs-flex-1">
            <div class="cs-d-flex m-b--5">
                <div class="m-r--10" translate>Roles:</div>
                <div class="font-bold">{{ notificationBlockDisplay.roles }}</div>
            </div>
            <div class="cs-d-flex">
                <div class="m-r--10">Message:</div>
                <div class="font-bold text-left">{{ notificationBlockDisplay.message }}</div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #delayBlock let-nodeData="node" let-headerText="blockHeaderText">
    <ng-container *ngIf="condition; then conditionEdge"></ng-container>
    <div [id]="blockId"
         [ngClass]="{'highlight-deletable': highlighDeletableNode}"
         [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''"
         class="task-block cs-delay-task-block cs-d-flex flex-column align-items-center">
        <div *ngIf="!isNew" class="pos-abt-full cursor-pointer task-action-link" (click)="editNode()"></div>
        <div class="node-heading mb-10">{{headerText}}</div>
        <div class="node-icon-content">
            <span><i class="mr-10 fal fa-clock fa-lg" aria-hidden="true"></i></span>
            <span translate>Delay</span>
        </div>
        <hr class="separator"/>
        <div class="cs-flex-1">
            <div class="font-bold"> {{ delayBlockDisplay.interval }} {{delayBlockDisplay.unit}}</div>
        </div>
    </div>
</ng-template>

<ng-template #dummyBlock let-nodeData="node" let-headerText="blockHeaderText">
    <div [id]="nodeData.id" class="task-block cs-dummy-task-block cs-d-flex flex-column align-items-center">
    </div>
</ng-template>

<ng-template #addJobBlock let-nodeData="node" let-headerText="blockHeaderText">
    <ng-container *ngIf="condition; then conditionEdge"></ng-container>
    <div [id]="blockId"
         [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''"
         class="task-block cs-addjob-task-block cs-d-flex flex-column align-items-center">
        <div *ngIf="!isNew" class="pos-abt-full cursor-pointer task-action-link" (click)="editNode()"></div>
        <div class="node-heading mb-10">{{headerText}}</div>
        <div class="node-icon-content">
            <span><i class="mr-10 fal fa-truck fa-lg" aria-hidden="true"></i></span>
            <span translate>Create a job</span>
        </div>
        <hr class="separator"/>
        <div class="cs-flex-1">
            <div class="cs-d-flex">
                <div class="m-r--10" translate>Job description:</div>
                <div class="font-bold">{{ addJobBlockDisply }}</div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #conditionalBlock let-nodeData="node" let-headerText="blockHeaderText">
    <div>
        <div class="rhombus"></div>
        <div class="rhombus2 pos-abt transformX-center" [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''" style="top:1px; z-index: 0"></div>
        <div class="rhombus3 pos-abt transformX-center cursor-pointer task-action-link" style="top:2px; z-index: 2;" (click)="editNode()"></div>
    </div>
    <div class="pos-abt-full w-100 rhombus-wrapper">
        <div [id]="id" class="task-block cs-conditional-task-block cs-d-flex flex-column align-items-center h-100" [ngClass]="{'highlight-deletable': highlighDeletableNode}">
            <div class="node-icon-content">
                <div class="fs"><i class="mr-10 fa-light fa-light fa-code-branch" aria-hidden="true"></i></div>
                <div translate>If statement</div>
            </div>
            <hr class="separator"/>
            <div class="cs-flex-0">
                <div class="cs-d-flex m-b--5">
                    <div class="font-bold">{{dagSourceModel.getFieldDisplayName(model['col_name'])}}</div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #conditionalDelayBlock  let-headerText="blockHeaderText">
    <ng-container *ngIf="condition; then conditionEdge"></ng-container>
    <div [id]="blockId"
    [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''"
    class="task-block cs-conditional-delay-task-block cs-d-flex flex-column align-items-center">
        <div *ngIf="!isNew" class="pos-abt-full cursor-pointer task-action-link" (click)="editNode()"></div>
        <div class="node-heading mb-10">{{headerText}}</div>
        <div class="node-icon-content">
            <span><i class="mr-10 fa-light fa-chess-clock fa-lg" aria-hidden="true"></i></span>
            <span translate>Field based delay</span>
        </div>
        <hr class="separator"/>
        <div class="cs-flex-0">
            <div class="font-bold"> {{ conditionalDelayBlockDisply }} </div>
        </div>
    </div>
</ng-template>
<ng-template #startSequenceBlock  let-headerText="blockHeaderText">
    <ng-container *ngIf="condition; then conditionEdge"></ng-container>
    <div [id]="blockId"
    [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''"
    class="task-block cs-start-sequence-task-block cs-d-flex flex-column align-items-center">
        <div *ngIf="!isNew" class="pos-abt-full cursor-pointer task-action-link" (click)="editNode()"></div>
        <div class="node-heading mb-10">{{headerText}}</div>
        <div class="node-icon-content">
            <span><i class="mr-10 fa-light fa-envelopes-bulk fa-lg" aria-hidden="true"></i></span>
            <span translate>Start sequence</span>
        </div>
        <hr class="separator"/>
        <div class="cs-flex-1">
            <div class="cs-d-flex m-b--5">
                <div class="m-r--10" translate>Send sequence to:</div>
                <div class="font-bold">{{ startSequenceBlockDisplay.sequenceSentTo }}</div>
            </div>
            <div class="cs-d-flex">
                <div class="m-r--10">Sequence template:</div>
                <div class="font-bold text-left">{{ startSequenceBlockDisplay.sequenceName }}</div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #setSalesPersonBlock  let-headerText="blockHeaderText">
    <ng-container *ngIf="condition; then conditionEdge"></ng-container>
    <div [id]="blockId"
    [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''"
    class="task-block cs-set-sales-person-block cs-d-flex flex-column align-items-center">
        <div *ngIf="!isNew" class="pos-abt-full cursor-pointer task-action-link" (click)="editNode()"></div>
        <div class="node-heading mb-10">{{headerText}}</div>
        <div class="node-icon-content">
            <span><i class="mr-10 fa-light fa-user-plus fa-lg" aria-hidden="true"></i></span>
            <span translate>Set sales person</span>
        </div>
        <hr class="separator"/>
        <div class="cs-flex-0">
            <div class="m-r--10">AssignTo:</div>
            <div class="font-bold"> {{ setSalesPersonBlockDisplay.AssignTo }} </div>
        </div>
    </div>
</ng-template>

<ng-template #sendProposalBlock  let-headerText="blockHeaderText">
    <ng-container *ngIf="condition; then conditionEdge"></ng-container>
    <div [id]="blockId"
    [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''"
    class="task-block cs-send-proposal-block cs-d-flex flex-column align-items-center">
        <div *ngIf="!isNew" class="pos-abt-full cursor-pointer task-action-link" (click)="editNode()"></div>
        <div class="node-heading mb-10">{{headerText}}</div>
        <div class="node-icon-content">
            <span><i class="mr-10 fal fa-envelope fa-lg" aria-hidden="true"></i></span>
            <span translate>Send proposal</span>
        </div>
        <hr class="separator"/>
        <div class="cs-flex-1">
            <div class="cs-d-flex m-b--5">
                <div class="m-r--10">To:</div>
                <div class="font-bold">{{ sendProposalBlockDisplay.toEmailTag }}</div>
            </div>
            <div class="cs-d-flex">
                <div class="m-r--10">Subject:</div>
                <div class="font-bold text-left">{{ sendProposalBlockDisplay.subject }}</div>
            </div>
            <div class="cs-d-flex">
                <div class="m-r--10">TemplateName:</div>
                <div class="font-bold text-left">{{ sendProposalBlockDisplay.templateName }}</div>
            </div>
        </div>
    </div>
</ng-template>



<app-common-modal-popups *ngIf="statusConfirmationModalConfig?.showModal"  [modalConfig]="statusConfirmationModalConfig"></app-common-modal-popups>

